import de from './de'
import en from './en'
import fr from './fr'

export interface Messages {
  [propName: string]: {
    [propName: string]: string
  }
}

const messages: Messages = {
  de,
  en,
  fr,
}

type enTranslationKeys = keyof typeof en
type deTranslationKeys = keyof typeof de
type frTranslationKeys = keyof typeof fr

export type TranslationKey =
  | enTranslationKeys
  | deTranslationKeys
  | frTranslationKeys

export default messages
